import GenericArrayTreeNode from './GenericArrayTreeNode';
import ArraySortable from './ArraySortable';
import { nullArray } from './ArraySortable';

export default class ArraySortedTreeNode extends GenericArrayTreeNode<ArraySortable> {
	private _zIndex: number;

	constructor () {
		super(ArraySortable, nullArray);
		this._zIndex = 0;
	}

	get zIndex () {
		return this._zIndex;
	}

	set zIndex (zIndex) {
		if (zIndex === this._zIndex) {
			return;
		}

		this._zIndex = zIndex;

		if (this.parent === null) {
			return;
		}

		this.parent.children.reposition(this);
		this._reposition();
	}

	_addChild (child: ArraySortedTreeNode) {
		super._addChild(child);
		this.children.bubbleSort(this.children.length - 1);
	}

	_reposition () {}
}
